import React from 'react';

export const XIcon = () => (
<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.69323 19H1.3199L8.72657 10.9373L0.0732327 0H6.8639L12.1806 6.64649L18.2672 0H21.6406L13.7939 8.62362L22.0806 19H15.1212L10.3179 12.9284L4.69323 19ZM5.8739 1.89299H4.0039L16.1039 17.1771H18.1132L5.8739 1.89299Z" fill="white"/>
</svg>
);